import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getAutomationLogs } from '@/services/dmAutomation.service';
import { queryKeys } from '@/hooks/queries/keys';

export const useAutomationLogs = (
    id: string,
    page = 1,
    limit = 20,
    options?: { enabled?: boolean },
) => {
    return useQuery({
        queryKey: queryKeys.dmAutomation.logs(id, page, limit),
        queryFn: () => getAutomationLogs(id, page, limit),
        enabled: (options?.enabled ?? true) && Boolean(id),
        placeholderData: keepPreviousData,
    });
};
